import {inject, Injectable, signal} from '@angular/core';
import {ToastrNotificationsService} from './toastr-notifications.service';

@Injectable({
  providedIn: 'root',
})
export class HelperService {
  copyButtonText = signal('Copy');

  toastrNotificationsService = inject(ToastrNotificationsService);

  copyToClipboard(content: string) {
    if (window.isSecureContext && navigator.clipboard) {
      navigator.clipboard.writeText(content).then(() => {
        this.copyButtonText.set('Copied');
        setTimeout(() => {
          this.copyButtonText.set('Copy');
        }, 3000);
        this.toastrNotificationsService.notifySuccess('Copied to clipboard');
      });
    }
  }
}
